import { AddonStatus, AddonType, GlobalTravelPassTabName } from 'my-account/constants';
import { ModelBase } from 'store/model-base';

export class GlobalTravelPass extends ModelBase {
    public static storeName: string = 'globalTravelPass';

    public header: string;
    public subtitle: string;
    public tabs: GlobalTravelPassTab[];
    public isInternational: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: GlobalTravelPass = super.create<GlobalTravelPass>(initData);
        toReturn.isInternational = toReturn.tabs.some((tab: GlobalTravelPassTab) => tab.pass === GlobalTravelPassTabName.INTERNATIONAL);

        return super.create<T>(toReturn);
    }
}

export interface GlobalTravelPassOption {
    content: string;
    destination: string;
}

export interface GlobalTravelPassLine {
    lineIdKey: string;
    nickname: string;
    phoneNumber: string;
    badge: string;
    status: AddonStatus;
    dataUsageContent?: string;
    dataUsed?: string;
    options: GlobalTravelPassOption[];
    lineDetails?: LineDetailsAddOnContent;
    removalRequestCode?: string;
}

export interface GlobalTravelPassTab {
    pass: string;
    status?: string;
    passName: string;
    subtitle?: string;
    body?: string;
    ctaContent?: string;
    ctaDestination?: string;
    lines: GlobalTravelPassLine[];
}

export interface LineDetailsAddOnContent {
    lineId?: string;
    status?: AddonStatus;
    type?: AddonType;
    headerContent: string;
    subtitleContent: string;
    price: string;
    body: string;
    removalRequestCode?: string;
    cta: {
        content: string;
        destination: string;
    };
}
